module.exports = __webpack_public_path__ + "img/Picture6.195692da.png";